/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { apiClient } from './client.js';

export interface TherapistStats {
  readonly totalClients: number;
  readonly sessionsToday: number;
  readonly sessionsTodayDone: number;
  readonly pendingNotes: number;
  readonly avgProgressPct: number | null;
}

export interface TherapistScheduleItem {
  readonly id: string;
  readonly clientName: string;
  readonly sessionType: string | null;
  readonly startIso: string;
  readonly status: string;
}

export interface TherapistTask {
  readonly id: string;
  readonly kind: 'note' | 'review';
  readonly clientName: string;
  readonly dueIso: string | null;
}

export interface WeeklyPoint {
  readonly weekIso: string;
  readonly sessions: number;
}

export interface CaseloadClient {
  readonly id: string;
  readonly name: string;
  readonly age: number | null;
  readonly progressPct: number;
  readonly sessions: number;
  readonly nextSessionIso: string | null;
}

export interface TherapistDashboard {
  readonly stats: TherapistStats;
  readonly todaySchedule: readonly TherapistScheduleItem[];
  readonly pendingTasks: readonly TherapistTask[];
  readonly weeklyActivity: readonly WeeklyPoint[];
  readonly clients: readonly CaseloadClient[];
}

export const therapistDashboardApi = {
  async overview(): Promise<TherapistDashboard> {
    const { data } = await apiClient.get<TherapistDashboard>('/therapist/dashboard');
    return data;
  },
};
